import React from 'react';
import { useReactFlow, useStore } from '@xyflow/react';
import { Input } from 'antd';
import styles from '../../timeline-node-manager.module.css';

type EventParamsProps = {
  nodeId: string;
};

export default function EventParams({ nodeId }: EventParamsProps) {
  const { setNodes } = useReactFlow();
  const node = useStore((state) => state.nodes.find((n) => n.id === nodeId));

  const onChangeParams = (key: string, value: string) => {
    setNodes((nodes) =>
      nodes.map((n) =>
        n.id === nodeId
          ? {
              ...n,
              data: {
                ...n.data,
                [key]: value,
              },
            }
          : n
      )
    );
  };

  if (!node) return null;

  return (
    <div>
      <span className={styles.label}>Name:</span>
      <Input
        value={(node.data?.name as any) ?? ''}
        onChange={(e) => onChangeParams('name', e.target.value)}
        className={styles.input}
      />
    </div>
  );
}
